






















































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { addColumnDefaults, IColumns } from '@ultraware/vue-helpers'
import { QIcon, QInput, QSelect, QSpace, QTable, QTd } from 'quasar'
import { IQTablePagination } from '@/quasar-types'
import TableStorageMixin from '../plugins/mixins/TableStorageMixin'
import { ISchoolCredit } from '@/store/school-credit'

@Component({
  components: { QInput, QIcon, QSpace, QSelect, QTable, QTd },
})
export default class SchoolCreditTable extends Mixins(TableStorageMixin) {
  @Prop({ required: true, type: Array }) public schoolCredit!: ISchoolCredit[]

  public namespace = 'schoolCreditTable'

  public filter = ''
  public visibleColumns: string[] = [
    'distributor_name', 'product_uid', 'title', 'organisation_id', 'school_name', 'amount', 'start_date']

  public pagination: IQTablePagination = {
    sortBy: 'product_uid',
    descending: true,
    rowsPerPage: 10,
    page: 1,
  }

  public rowsPerPageOptions: number[] = [10, 15, 30, 50, 500]

  public columns: IColumns[] = addColumnDefaults([
    {
      label: 'Distributeur',
      name: 'distributor_name',
    },
    {
      label: 'EAN/ProductID',
      name: 'product_uid',
    },
    {
      label: 'Titel',
      name: 'title',
    },
    {
      label: 'BDLSchoolID',
      name: 'organisation_id',
    },
    {
      label: 'Schoolnaam',
      name: 'school_name',
    },
    {
      label: 'Aantal',
      name: 'amount',
    },
    {
      label: 'Startdatum',
      name: 'start_date',
      field: (row: ISchoolCredit): string => this.$options.filters!.date(row.start_date),
    },
  ])
}
